<template>
  <input type="text" v-model="value" v-bind:readonly="readonly" />
</template>

<script>
export default {
  name: "DollarBox",
  props: ["modelValue", "readonly", "type"],
  data() {
    return {
      localValue: this.modelValue,
    };
  },
  methods: {
    formatCurrency(val) {
      if (val.constructor == Number) val = String(val);
      val = Number(
        val
          .replace(/[^0-9.]/g, "")
          .split(".", 2)
          .join(".")
      ).toFixed(0);
      return "$" + val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatPercent(val) {
      return String(val).replace(/\D/g, "") + "%";
    },
  },
  computed: {
    value: {
      get() {
        if (this.type == "percent") return this.formatPercent(this.localValue);
        return this.formatCurrency(this.localValue);
      },
      set(val) {
        if (this.readonly) return;
        this.$emit(
          "update:modelValue",
          Number(
            val
              .replace(/[^0-9.]/g, "")
              .split(".", 2)
              .join(".")
          ).toFixed(0)
        );
        this.localValue = val;
      },
    },
  },
  watch: {
    modelValue(val) {
      this.localValue = val;
    },
  },
};
</script>